import { HttpPollingRequestInit } from '@nice-ccf/core-sdk';

export interface HttpPollingRequestParam {
  url: string;
  request: HttpPollingRequestInit;
  key?: any;
}
